export enum SaleCategoryFamilyName {
  ancien = 'Ancien',
  psla = 'PSLA',
  terrain = 'Terrain',
  vefa = 'VEFA'
}
